"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _FunnelTrend = _interopRequireDefault(require("@rsuite/icon-font/lib/charts/FunnelTrend"));

// Generated by script, don't edit it please.
var FunnelTrend = (0, _createSvgIcon["default"])({
  as: _FunnelTrend["default"],
  ariaLabel: 'funnel trend',
  category: 'charts',
  displayName: 'FunnelTrend'
});
var _default = FunnelTrend;
exports["default"] = _default;
module.exports = exports.default;